import { Provider, useSelector } from 'react-redux'
import './App.scss'
import ScrollTop from './ScrollTop'
import {
    DeviceMode,
    GoTopPage,
    PrimaryLayout,
} from './share/Components'
import store, { persistor } from './storeManager/store'
import { PersistGate } from 'redux-persist/integration/react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { QueryClient } from 'react-query'
import { QueryClientProvider } from 'react-query'
import { ReducerType } from './storeManager/ReducerType'



const queryClient = new QueryClient()
function AppNoAuth({ children }) {
    const Layout = children.type.Layout || PrimaryLayout
    const GoToPage = children.type.GoToPage || GoTopPage
    const device = useSelector<ReducerType, DeviceModeInterface>(
        (state) => state.reducerDevice
    )


    return (
        <>
            <PersistGate persistor={persistor}>
                <DeviceMode />
                <ScrollTop goTopPage={<GoToPage />}>
                    <>
                        <Layout>{children}</Layout>
                        <ToastContainer
                            position={`${device.Desktop ? 'top-right' : 'top-center'}`}
                            bodyClassName={'text-center text-xs '}
                            toastClassName={'!mb-1 '}
                            className={'xs:grid xs:grid-cols-2 xs:gap-1 !z-[9999999999] '}
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme='light'
                        />
                    </>
                </ScrollTop>
            </PersistGate>
        </>
    )
}

function AppWrapper<ComponentProps>(
    Component: React.FunctionComponent<ComponentProps>
) {
    function ComponentTemp(props: ComponentProps) {
        return (
            <Provider store={store}>
                <QueryClientProvider client={queryClient}>
                    <Component {...props!} />
                </QueryClientProvider>
            </Provider>
        )
    }

    return ComponentTemp
}
export default AppWrapper(AppNoAuth)
